import React from 'react';


const Footer = () => {
    return (
        <footer className="bg-gray-800 text-white mt-12">
            <div className="container mx-auto px-4 py-8">
                <div className="text-center">
                    <p>© 2025 MiniMarket. Все права защищены.</p>
                    <p className="text-gray-400 text-sm mt-2">
                        Учебный мини-маркетплейс
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;